import { createSlice } from "@reduxjs/toolkit";
import axios from "src/utils/axios";
import { getSavedQuestions, handleResultsTime } from "./gamificationDrawer";

const APP_BASE_URL = `${process.env.REACT_APP_API_URL}/events/api/v1`;
interface ITestcase {
  explanation: string;
  score_deduction: boolean;
  score: number;
  input: string;
  output: string;
  is_example: boolean;
  disable: boolean;
  is_corner_case: boolean;
  test_case_passed: boolean;
  test_case_id: number;
}

interface ILanguage {
  id: string;
  name: string;
}

interface IGetQuestion {
  id: string;
  type: string;
  level: string;
  score: string;
  time: string;
  details: boolean;
  difficulty: string;
  question: string;
  info: string;
  subType: string;
  test_case_id: number;
}

interface IOption {
  option_id?: string;
  option: string;
  isCorrect?: boolean;
  percentage?: string;
}

interface IGetMCQQuestion {
  id: string;
  isQuestionShown: boolean;
  question: string;
  subType: string;
  type: string;
  no: number;
  options?: IOption[];
}
interface IGetOneQuestion {
  type: string;
  parentId: string;
  question: string;
  info: string;
  score: number;
  isRequired: boolean;
  time: number;
  difficulty: string;
  validated: boolean;
  codes: [
    {
      language_id: number;
      language_name: string;
      code: string;
      solution: string;
    }
  ];
  test_cases: [
    {
      explanation: string;
      score_deduction: boolean;
      score: number;
      input: string;
      output: string;
      is_example: boolean;
      disable: boolean;
      is_corner_case: boolean;
      test_case_passed: boolean;
      test_case_id: string;
    }
  ];
}

interface ICodeQuestion {
  normalTestCase?: ITestcase[];
  language?: ILanguage[];
  getQuestion: IGetQuestion[];
  getMCQQuestion: IGetMCQQuestion[];
  getParticularQuestion: IGetOneQuestion[];
  getParticularQuestionMcq: IGetMCQQuestion[];
  metaData: {
    items: number;
    page: number;
    pages: number;
    pagesize: number;
  };
  id: string;
  validated: boolean;
  checkTestCase: boolean;
  testLoader: boolean;
  codeBoolean: boolean;
  searchBoolean: boolean;
  codeLength: number;
  questionAdded: boolean;
  isQuestionLoading: boolean;
  codeLoader: boolean;
}

const initialState: ICodeQuestion = {
  normalTestCase: [],
  language: [],
  getQuestion: [],
  getParticularQuestion: [],
  getParticularQuestionMcq: [],
  getMCQQuestion: [],
  metaData: {
    items: 0,
    page: 1,
    pages: 1,
    pagesize: 10,
  },
  id: "",
  validated: false,
  checkTestCase: false,
  testLoader: false,
  codeBoolean: false,
  searchBoolean: true,
  codeLength: 0,
  questionAdded: false,
  isQuestionLoading: false,
  codeLoader: false,
};

const slice = createSlice({
  name: "codeQuestion",
  initialState,
  reducers: {
    setNormalTestCase(state, action) {
      state.normalTestCase = action.payload;
    },
    setLanguage(state, action) {
      state.language = action.payload;
    },
    setGetQuestion(state, action) {
      state.getQuestion = action.payload;
    },
    setOneQuestion(state, action) {
      state.getParticularQuestion = action.payload;
    },
    setOneQuestionMcq(state, action) {
      state.getParticularQuestionMcq = action.payload;
    },
    setpagination(state, action) {
      state.metaData = action.payload;
    },
    setPage(state, action) {
      state.metaData.page = action.payload;
    },
    setGetMCQQuestion(state, action) {
      state.getMCQQuestion = action.payload;
    },
    ToggleQuestion(state, action) {
      const savedQuestions = JSON.parse(JSON.stringify(state.getMCQQuestion));
      for (const question of savedQuestions) {
        if (action.payload.id === question.id) {
          question.isQuestionShown = !question.isQuestionShown;
        } else if (question.isQuestionShown) {
          question.isQuestionShown = false;
        }
      }
      state.getMCQQuestion = savedQuestions;
    },
    setPageSize(state, action) {
      state.metaData.pagesize = action.payload;
    },
    setId(state, action) {
      state.id = action.payload;
    },
    setCodeBoolean(state, action) {
      state.codeBoolean = action.payload;
    },
    setSearchBoolean(state, action) {
      state.searchBoolean = action.payload;
    },
    setCodeLength(state, action) {
      state.codeLength = action.payload;
    },
    setCheckTestCase(state, action) {
      state.checkTestCase = action.payload;
    },
    setValidated(state, action) {
      state.validated = action.payload;
    },
    setTestLoader(state, action) {
      state.testLoader = action.payload;
    },
    setQuestionAdded(state, action) {
      state.questionAdded = action.payload;
    },
    setIsQuestionLoading(state, action) {
      state.isQuestionLoading = action.payload;
    },
    setCodeLoader(state, action) {
      state.codeLoader = action.payload;
    }
  },
});
export const codeGamificationActions = slice.actions;
export const reducer = slice.reducer;

export const normalTestCase1 = (list) => async (dispatch) => {
  dispatch(slice.actions.setNormalTestCase(list));
};
export const setId1 = (id) => async (dispatch) => {
  dispatch(slice.actions.setId(id));
};
export const setCodeBoolean1 = (boolValue) => async (dispatch) => {
  dispatch(slice.actions.setCodeBoolean(boolValue));
};
export const setCodeLength1 = (Value) => async (dispatch) => {
  dispatch(slice.actions.setCodeLength(Value));
};

export const setSearchBoolean1 = (Value) => async (dispatch) => {
  dispatch(slice.actions.setSearchBoolean(Value));
};

export const setValidated1 = (Value) => async (dispatch) => {
  dispatch(slice.actions.setValidated(Value));
};

export const toggleQuestionInfo = (data) => (dispatch) => {
  dispatch(slice.actions.ToggleQuestion(data));
};
export const toggleQuestionadded = () => (dispatch) => {
  dispatch(slice.actions.setQuestionAdded(false));
};

export const getSavedMCQQuestions =
  (pageSize, page, question, enqueueSnackbar) => async (dispatch) => {
    try {
      dispatch(slice.actions.setIsQuestionLoading(true));
      const savedQuestionMCQResponse = await axios.get(
        `${APP_BASE_URL}/question?type=mcq&meta=true&pageSize=${pageSize}&page=${page}&question=${question}&status=draft&subType=system`
      );
      if (!savedQuestionMCQResponse?.data?.status) {
        throw new Error(savedQuestionMCQResponse?.data?.message);
      }
      const metaData = {
        items: savedQuestionMCQResponse?.data?.metaData?.items,
        page: savedQuestionMCQResponse?.data?.metaData?.page,
        pages: savedQuestionMCQResponse?.data?.metaData?.pages,
        pagesize: savedQuestionMCQResponse?.data?.metaData?.pagesize,
      };
      dispatch(slice.actions.setpagination(metaData));
      dispatch(
        slice.actions.setGetMCQQuestion(savedQuestionMCQResponse?.data?.data)
      );
    } catch (error) {
      enqueueSnackbar(
        error?.message || error || "Unable to fetch saved question",
        {
          variant: "error",
          preventDuplicate: true,
          autoHideDuration: 5000,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
        }
      );
    } finally {
      dispatch(slice.actions.setIsQuestionLoading(false));
    }
  };

export const setLanguage1 = () => async (dispatch) => {
  try {
    const response = await axios.get(
      `${APP_BASE_URL}/question/languages`
    );
    const list = [];
    response?.data?.data?.map((item) => {
      list.push(item);
    });
    dispatch(slice.actions.setLanguage(list));
  } catch (error) {
    throw new Error(error);
  }
};

export const submitCodeQuestion =
  (enqueueSnackbar, data, pageSize, page) => async (dispatch) => {
    try {
      const submitQuestionResponse = await axios.post(
        `${APP_BASE_URL}/question`,
        data
      );

      if (submitQuestionResponse?.data?.status) {
        dispatch(getParticularQuestion1(submitQuestionResponse?.data?.data));
        dispatch(slice.actions.setId(submitQuestionResponse?.data?.data));
        dispatch(getSavedCodeQuestions(pageSize, page, enqueueSnackbar));
        dispatch(getSavedQuestions(enqueueSnackbar));
      }

      if (!submitQuestionResponse?.data?.status) {
        throw new Error(submitQuestionResponse?.data?.message);
      }
    } catch (error) {
      enqueueSnackbar(error?.message || error || "Question creation failed", {
        variant: "error",
        preventDuplicate: true,
        autoHideDuration: 5000,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      });
    }
  };

export const fetchQuestions = async (
  url,
  pageSize,
  page,
  enqueueSnackbar,
  dispatch
) => {
  try {
    const response = await axios.get(url);
    if (!response?.data?.status) {
      throw new Error(response?.data?.message);
    }
    const metaData = {
      items: response?.data?.metaData?.items,
      page: response?.data?.metaData?.page,
      pages: response?.data?.metaData?.pages,
      pagesize: response?.data?.metaData?.pagesize,
    };
    dispatch(slice.actions.setpagination(metaData));
    dispatch(slice.actions.setGetQuestion(response?.data?.data));
  } catch (error) {
    enqueueSnackbar(error?.message || error || "Unable to fetch questions", {
      variant: "error",
      preventDuplicate: true,
      autoHideDuration: 5000,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right",
      },
    });
  }finally {
  dispatch(slice.actions.setCodeLoader(false));
}
};

export const getSavedCodeQuestions = (
  pageSize,
  page,
  enqueueSnackbar
) => async (dispatch) => {
  dispatch(slice.actions.setCodeLoader(true));
  const url = `${APP_BASE_URL}/question?type=code&meta=true&pageSize=${pageSize}&page=${page}&status=draft&subType=system`;
  await fetchQuestions(url, pageSize, page, enqueueSnackbar, dispatch);
};

export const getSearchCodeQuestions =
  (pageSize, page, question, enqueueSnackbar, subType, filterArray = [], sortBy = "", sortMode = 1) => async (dispatch) => {
    try {
      dispatch(slice.actions.setCodeLoader(true));
      let queryString = `type=code&meta=true&pageSize=${pageSize}&page=${page}&question=${question}&status=draft&subType=${subType}`;

      // Add filter parameters
      if (Array.isArray(filterArray) && filterArray.length > 0) {
        filterArray.forEach(item => {
          if (item.type && item.value) {
            const param = item.type.toLowerCase();
            queryString += `&${param}=${item.value}`;
          }
        });
      }

      // Add sort parameters
      if (sortBy) {
        queryString += `&sortBy=${sortBy}&sortMode=${sortMode}`;
      }

      const savedQuestionCodeResponse = await axios.get(
        `${APP_BASE_URL}/question?${queryString}`
      );
      if (!savedQuestionCodeResponse?.data?.status) {
        throw new Error(savedQuestionCodeResponse?.data?.message);
      }
      const metaData = {
        items: savedQuestionCodeResponse?.data?.metaData?.items,
        page: savedQuestionCodeResponse?.data?.metaData?.page,
        pages: savedQuestionCodeResponse?.data?.metaData?.pages,
        pagesize: savedQuestionCodeResponse?.data?.metaData?.pagesize,
      };
      dispatch(slice.actions.setpagination(metaData));
      dispatch(
        slice.actions.setGetQuestion(savedQuestionCodeResponse?.data?.data)
      );
      dispatch(setSearchBoolean1(false));
    } catch (error) {
      enqueueSnackbar(
        error?.message || error || "Unable to fetch saved question",
        {
          variant: "error",
          preventDuplicate: true,
          autoHideDuration: 5000,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
        }
      );
    } finally {
      dispatch(slice.actions.setCodeLoader(false));
    }
  };

export const getFilterCodeQuestions = (
  pageSize,
  page,
  filterArray,
  enqueueSnackbar,
  subType,
  searchQuery = "",
  sortBy = "",
  sortMode = 1
) => async (dispatch) => {
  dispatch(slice.actions.setCodeLoader(true));
  let linkData = "";
  let queryString = "";

  if (Array.isArray(filterArray) && filterArray.length > 0) {
    filterArray.forEach(item => {
      if (item.type && item.value) {
        const param = item.type.toLowerCase();
        queryString += `&${param}=${item.value}`;
      }
    });
  }

  if (searchQuery && searchQuery.trim()) {
    queryString += `&question=${encodeURIComponent(searchQuery.trim())}`;
  }

  if (sortBy) {
    queryString += `&sortBy=${sortBy}&sortMode=${sortMode}`;
  }

  linkData = `${APP_BASE_URL}/question?type=code&meta=true&pageSize=${pageSize}&page=${page}&status=draft&subType=${subType}${queryString}`;

  await fetchQuestions(linkData, pageSize, page, enqueueSnackbar, dispatch);
};

export const getSortedCodeQuestions = (
  pageSize,
  page,
  sortBy,
  sortMode,
  enqueueSnackbar,
  subType,
  searchQuery = "",
  filterArray = []
) => async (dispatch) => {
  dispatch(slice.actions.setCodeLoader(true));
  let queryString = `type=code&meta=true&pageSize=${pageSize}&page=${page}&status=draft&subType=${subType}&sortBy=${sortBy}&sortMode=${sortMode}`;

  if (searchQuery && searchQuery.trim()) {
    queryString += `&question=${encodeURIComponent(searchQuery.trim())}`;
  }

  // Add filter parameters if provided
  if (Array.isArray(filterArray) && filterArray.length > 0) {
    filterArray.forEach(item => {
      if (item.type && item.value) {
        const param = item.type.toLowerCase();
        queryString += `&${param}=${item.value}`;
      }
    });
  }

  const linkData = `${APP_BASE_URL}/question?${queryString}`;
  await fetchQuestions(linkData, pageSize, page, enqueueSnackbar, dispatch);
};

export const addCodeQuestion =
  (testId, id, enqueueSnackbar) => async (dispatch) => {
    try {
      const publishResponse = await axios.put(
        `${APP_BASE_URL}/test/${testId}/add-question/${id}`
      );
      if (!publishResponse?.data?.status) {
        throw new Error(publishResponse?.data?.message);
      }
      dispatch(getParticularQuestion1(publishResponse?.data?.data?.id));
      dispatch(getSavedQuestions(enqueueSnackbar));
    } catch (error) {
      enqueueSnackbar(error?.message || error || "Question add failed", {
        variant: "error",
        preventDuplicate: true,
        autoHideDuration: 5000,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      });
    }
  };

export const addMcqQuestion =
  (testId, id, enqueueSnackbar) => async (dispatch) => {
    try {
      const publishResponse = await axios.put(
        `${APP_BASE_URL}/test/${testId}/add-question/${id}`
      );
      if (!publishResponse?.data?.status) {
        throw new Error(publishResponse?.data?.message);
      }
      dispatch(slice.actions.setQuestionAdded(true));
      dispatch(getSavedQuestions(enqueueSnackbar, true));
    } catch (error) {
      enqueueSnackbar(error?.message || error || "Question add failed", {
        variant: "error",
        preventDuplicate: true,
        autoHideDuration: 5000,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      });
    }
  };

export const addCodeQuestionPublish =
  (testId, id, enqueueSnackbar, codeLength, pageSize, time) =>
    async (dispatch) => {
      try {
        const publishResponse = await axios.put(
          `${APP_BASE_URL}/test/${testId}/add-question/${id}`
        );
        if (!publishResponse?.data?.status) {
          throw new Error(publishResponse?.data?.message);
        }
        dispatch(
          publishCodeQuestion(
            publishResponse?.data?.data?.id,
            enqueueSnackbar,
            codeLength + 1,
            pageSize,
            time
          )
        );
      } catch (error) {
        enqueueSnackbar(error?.message || error || "Question add failed", {
          variant: "error",
          preventDuplicate: true,
          autoHideDuration: 5000,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
        });
      }
    };

export const getParticularQuestion1 = (id) => async (dispatch) => {
  dispatch(slice.actions.setId(id));
  try {
    const response = await axios.get(
      `${APP_BASE_URL}/question?id=${id}`
    );
    dispatch(slice.actions.setOneQuestion(response?.data?.data));
    dispatch(slice.actions.setCheckTestCase(false));
  } catch (error) {
    throw new Error(error);
  }
};

export const getParticularQuestionMcq = (id) => async (dispatch) => {
  dispatch(slice.actions.setId(id));
  try {
    const response = await axios.get(
      `${APP_BASE_URL}/question?id=${id}`
    );
    dispatch(slice.actions.setOneQuestionMcq(response?.data?.data));
    dispatch(slice.actions.setCheckTestCase(false));
  } catch (error) {
    throw new Error(error);
  }
};

export const publishCodeQuestion =
  (id, enqueueSnackbar, codeLength, pageSize, time) => async (dispatch) => {
    try {
      const publishResponse = await axios.put(
        `${APP_BASE_URL}/question/${id}/publish`
      );
      if (!publishResponse?.data?.status) {
        throw new Error(publishResponse?.data?.message);
      }
      if (publishResponse?.data?.status) {
        dispatch(handleResultsTime(time));
        dispatch(slice.actions.setCodeLength(codeLength + 1));
        dispatch(getSavedCodeQuestions(pageSize, 1, enqueueSnackbar));
        dispatch(getSavedQuestions(enqueueSnackbar));
      }
    } catch (error) {
      enqueueSnackbar(error?.message || error || "Failed to publish", {
        variant: "error",
        preventDuplicate: true,
        autoHideDuration: 5000,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      });
    }
  };

export const getSearchMCQQuestions =
  (pageSize, page, question, enqueueSnackbar) => async (dispatch) => {
    try {
      dispatch(slice.actions.setIsQuestionLoading(true));
      const savedQuestionCodeResponse = await axios.get(
        `${APP_BASE_URL}/question?type=mcq&subType=system&meta=true&pageSize=${pageSize}&page=${page}&question=${question}&status=draft`
      );
      if (!savedQuestionCodeResponse?.data?.status) {
        throw new Error(savedQuestionCodeResponse?.data?.message);
      }
      const metaData = {
        items: savedQuestionCodeResponse?.data?.metaData?.items,
        page: savedQuestionCodeResponse?.data?.metaData?.page,
        pages: savedQuestionCodeResponse?.data?.metaData?.pages,
        pagesize: savedQuestionCodeResponse?.data?.metaData?.pagesize,
      };
      dispatch(slice.actions.setpagination(metaData));
      dispatch(
        slice.actions.setGetMCQQuestion(savedQuestionCodeResponse?.data?.data)
      );
    } catch (error) {
      enqueueSnackbar(
        error?.message || error || "Unable to fetch saved question",
        {
          variant: "error",
          preventDuplicate: true,
          autoHideDuration: 5000,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
        }
      );
    } finally {
      dispatch(slice.actions.setIsQuestionLoading(false));
    }
  };

export const clearParticularQuestion = () => async (dispatch) => {
  dispatch(slice.actions.setOneQuestion([]));
};

export const clearParticularMCQQuestion = () => async (dispatch) => {
  dispatch(slice.actions.setOneQuestionMcq([]));
};

export const setCheckTestCase1 = (state:boolean=false) => async (dispatch) => {
  dispatch(slice.actions.setCheckTestCase(state));
};

export const accessMetaData = (pageSize, data) => async (dispatch) => {
  dispatch(slice.actions.setPage(data));
  dispatch(slice.actions.setPageSize(pageSize));
};
export const sortSavedCodeQuestions = (arr) => async (dispatch) => {
  dispatch(slice.actions.setGetQuestion(arr));
};

export const updateCodingQuestion = (id, data, enqueueSnackbar) => async () => {
  try {
    const publishResponse = await axios.put(
      `${APP_BASE_URL}/question/${id}`,
      data
    );
    if (!publishResponse?.data?.status) {
      throw new Error(publishResponse?.data?.message);
    }
  } catch (error) {
    enqueueSnackbar(error?.message || error || "Question update failed", {
      variant: "error",
      preventDuplicate: true,
      autoHideDuration: 5000,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right",
      },
    });
  }
};

export const updateCodingQuestion1 =
  (id, data, enqueueSnackbar, pageSize, page) => async (dispatch) => {
    try {
      const publishResponse = await axios.post(
        `${APP_BASE_URL}/question/${id}/code`,
        data
      );
      if (!publishResponse?.data?.status) {
        throw new Error(publishResponse?.data?.message);
      }
      if (publishResponse?.data?.status) {
        dispatch(getSavedCodeQuestions(pageSize, page, enqueueSnackbar));
        dispatch(getParticularQuestion1(id));
      }
    } catch (error) {
      enqueueSnackbar(error?.message || error || "Question update failed", {
        variant: "error",
        preventDuplicate: true,
        autoHideDuration: 5000,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      });
    }
  };

export const addCodeTestCase = (id, enqueueSnackbar) => async (dispatch) => {
  const data = {
    explanation: "",
    score_deduction: false,
    score: 10,
    input: "",
    output: "",
    is_example: true,
    disable: false,
    is_corner_case: false,
  };
  try {
    const submitQuestionResponse = await axios.post(
      `${APP_BASE_URL}/question/${id}/test_case`,
      data
    );

    dispatch(getParticularQuestion1(id));
    if (!submitQuestionResponse?.data?.status) {
      throw new Error(submitQuestionResponse?.data?.message);
    }
  } catch (error) {
    enqueueSnackbar(error?.message || error || "Testcase creation failed", {
      variant: "error",
      preventDuplicate: true,
      autoHideDuration: 2000,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right",
      },
    });
  }
};

export const testTestCase =
  (id, data, enqueueSnackbar, list) => async (dispatch) => {
    try {
      dispatch(slice.actions.setTestLoader(true));
      const submitQuestionResponse = await axios.post(
        `${APP_BASE_URL}/question/validate/${id}`,
        data
      );
      if (submitQuestionResponse?.data?.status) {
        dispatch(slice.actions.setCheckTestCase(true));
        const data1 = submitQuestionResponse?.data?.data?.submission;
        const list2 = [];
        data1.map((item, i) => {
          list2.push({
            explanation: list[i]?.explanation,
            score_deduction: list[i]?.score_deduction,
            score: list[i]?.score,
            input: list[i]?.input,
            output: list[i]?.output,
            is_example: list[i]?.is_example,
            disable: list[i]?.disable,
            is_corner_case: list[i]?.is_corner_case,
            test_case_passed: item?.test_case_passed,
            test_case_id: item?.test_case_id,
          });
        });
        dispatch(slice.actions.setNormalTestCase(list2));
        dispatch(
          slice.actions.setValidated(
            submitQuestionResponse?.data?.data?.validated
          )
        );
      }
      if (!submitQuestionResponse?.data?.status) {
        throw new Error(submitQuestionResponse?.data?.message);
      }
    } catch (error) {
      enqueueSnackbar(error?.message || error || "Testcase checking failed", {
        variant: "error",
        preventDuplicate: true,
        autoHideDuration: 2000,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      });
    }
    dispatch(slice.actions.setTestLoader(false));
  };

export const updateOrDeleteTestCase = (
  id,
  testCaseId,
  data,
  enqueueSnackbar,
  isDelete = false
) => async (dispatch) => {
  const method = isDelete ? "delete" : "put";
  const action = isDelete ? "delete" : "update";

  try {
    const response = await axios[method](
      `${APP_BASE_URL}/question/${id}/test-case/${testCaseId}`,
      isDelete ? undefined : data
    );

    if (response?.data?.status) {
      dispatch(getParticularQuestion1(id));
    } else {
      throw new Error(response?.data?.message);
    }
  } catch (error) {
    enqueueSnackbar(
      `Testcase ${action}tion failed: ${error?.message || error}`,
      {
        variant: "error",
        preventDuplicate: true,
        autoHideDuration: 2000,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      }
    );
  }
};

// Usage example for updating a test case
export const updateTestCase1 = (
  testCaseId,
  id,
  data,
  enqueueSnackbar
) => async (dispatch) => {
  await dispatch(updateOrDeleteTestCase(id, testCaseId, data, enqueueSnackbar));
};

// Usage example for deleting a test case
export const deleteTestCase1 = (
  testCaseId,
  id,
  enqueueSnackbar
) => async (dispatch) => {
  await dispatch(updateOrDeleteTestCase(id, testCaseId, null, enqueueSnackbar, true));
};


export default slice;
